import { render } from "./LoadingCmp.vue?vue&type=template&id=ba6802ca&ts=true"
import script from "./LoadingCmp.vue?vue&type=script&lang=ts"
export * from "./LoadingCmp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__